// Allow search on english AND non english characters
const SEARCH_VALIDATOR = /[^@.+-_#\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]/gi

export type ValidateSearchString = (searchString: string) => string

export default function validateSearchString(searchString: string) {
  return searchString.replace(SEARCH_VALIDATOR, '')
}
